import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';

@Component({
  selector: 'app-lottie',
  templateUrl: './lottie.component.html',
  styleUrls: ['./lottie.component.css']
})
export class LottieComponent {

  public size: string = '450px';
  public path: string = '';
  public msg: string = '';
  options: AnimationOptions;
  styles: Partial<CSSStyleDeclaration> = { margin: '0 auto' };

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.options = {
      path: this.path,
      loop: false
    };
  }

  animationCreated(animationItem: AnimationItem) {
    animationItem.addEventListener('complete', () => {
      if (!this.msg) {
        this.activeModal.close(this.msg);
      } else {
        setTimeout(() => {
          this.activeModal.close();
        }, 1000);
      }
    });
  }
}
